import { useState } from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { DownOutlined } from "@ant-design/icons"
import styles from "./index.module.css"

// A titled section that collapses/expands via a chevron toggle. `action` renders an optional
// control (e.g. an edit button) to the left of the chevron in the header.
const CollapsibleSection = ({ title, count, defaultOpen = false, action, children, className }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const toggle = () => setIsOpen((prev) => !prev)

  return (
    <div className={`${styles.section} ${className || ""}`}>
      <Flex align="center" justify="space-between" className={styles.header}>
        <button type="button" className={styles.titleButton} onClick={toggle} aria-expanded={isOpen}>
          <span className={styles.title}>{title}</span>
          {count != null && <span className={styles.count}>({count})</span>}
        </button>
        <Flex align="center" gap={8}>
          {action}
          <button type="button" className={styles.chevronButton} onClick={toggle} aria-label="Toggle section">
            <DownOutlined className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`} />
          </button>
        </Flex>
      </Flex>
      {isOpen && <div className={styles.body}>{children}</div>}
    </div>
  )
}

CollapsibleSection.propTypes = {
  title: PropTypes.node.isRequired,
  count: PropTypes.number,
  defaultOpen: PropTypes.bool,
  action: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
}

export default CollapsibleSection
